export default __webpack_public_path__ + "static/media/F2.c8baf120.mp3";